module.exports = __webpack_public_path__ + "img/hiking001.f38da15f.jpg";